import React  from 'react';
import { ReferenceField, TextField } from "react-admin";
import { ListGuesser } from "@api-platform/admin";

const BlogCategoryList = (props) => (
    <ListGuesser {...props}>
      <TextField source="name" />
      <TextField source="title" />
      <TextField source="slug" />
      <ReferenceField label="Language" source="language" reference="languages">
        <TextField source="name" />
      </ReferenceField>
      <ReferenceField label="File" source="file" reference="files">
        <TextField source="title" />
      </ReferenceField>
    </ListGuesser>
  );

export default BlogCategoryList;